import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://riyadiyat-jahiza.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'احصل على الرياضيات جاهزة™ الآن',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-68" data-mp="qk21j7bspmfj">
      <span data-id="element-69" data-mp="15ahn4n84iwe8">{label}</span>
      <ArrowLeftIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:-translate-x-0.5" aria-hidden="true" data-id="element-70" data-mp="15bayy2lxwc38" />
    </a>;
}